import React from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from './contexts/theme';
import Auth0ProviderWithHistory from './components/Auth0ProviderWithHistory';
import useAuthCache from './hooks/useAuthCache';
import AppRoutes from './Router';

function AuthCacheHandler() {
  useAuthCache();
  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Auth0ProviderWithHistory>
        <AuthCacheHandler />
        <AppRoutes />
        <ToastContainer autoClose={5000} draggable transition={Slide} />
      </Auth0ProviderWithHistory>
    </ThemeProvider>
  );
}

export default App;
